import loadingAnimation from 'components/atoms/LoadingIndicator/assets/Mobi_loadingSurvey.json';
import classes from 'components/atoms/LoadingScreen/LoadingScreen.module.scss';
import Component from 'components/pages/Dashboard/Dashboard';
import Lottie from 'lottie-react';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('dashboard');
export default buildPage(Component, {
  requiresAuthentication: true,
  metaData: {
    title: 'Dashboard',
    description: 'Paid Surveys | Get Rewarded For Your Opinion',
  },
  loadingAnimation: (
    <div className={classes.root}>
      <Lottie animationData={loadingAnimation} style={{ width: '150px', height: '150px' }} />
    </div>
  ),
});
